import { useState, useEffect } from "react";
import MultiRangeSlider from "multi-range-slider-react";
import "./CustomRange.css";

const RangeSlider = ({ min, max, minRangeValue, maxRangeValue, setMinRangeValue, setMaxRangeValue }) => {
  const [tempMin, setTempMin] = useState(minRangeValue);
  const [tempMax, setTempMax] = useState(maxRangeValue);

  useEffect(() => {
    setTempMin(minRangeValue);
    setTempMax(maxRangeValue);
  }, [minRangeValue, maxRangeValue]);

  const handleBlur = () => {
    const minVal = parseInt(tempMin);
    const maxVal = parseInt(tempMax);

    if (!isNaN(minVal) && !isNaN(maxVal)) {
      if (minVal <= maxVal) {
        setMinRangeValue(minVal);
        setMaxRangeValue(maxVal);
      } else {
        setTempMin(minRangeValue);
        setTempMax(maxRangeValue);
      }
    }
  };

  return (
    <div className="mb-3">
      <div className="d-flex gap-2 mb-2">
        <input
          type="number"
          className="form-control"
          placeholder="Min"
          value={tempMin}
          onChange={(e) => setTempMin(e.target.value)}
          onBlur={handleBlur}
        />
        <input
          type="number"
          className="form-control"
          placeholder="Max"
          value={tempMax}
          onChange={(e) => setTempMax(e.target.value)}
          onBlur={handleBlur}
        />
      </div>

      <MultiRangeSlider
        min={min}
        max={max}
        step={10}
        ruler={false}
        label={false}
        minValue={minRangeValue}
        maxValue={maxRangeValue}
        onInput={(e) => {
          setMinRangeValue(e.minValue);
          setMaxRangeValue(e.maxValue);
        }}
        style={{
          width: "100%",
          height: "10px",
          backgroundColor: "#fff",
          boxShadow: "0px",
        }}
        barInnerColor="#DBDFE9"
      />
    </div>
  );
};

export default RangeSlider;
